import axios from "axios";
import { Employee } from "../../model/user";

export const doCompanyProfileUpdateApiCall = ({
  data,
}: {
  data: {
    name?: string;
    companyRole?: string;
    isHeadOfDepartment?: boolean;
    managerEmployeeId?: number;
  };
}) => {
  return axios.put<Employee>(`/api/auth/company-profile`, data);
};
